import K from "../../utilities/constants";
import { valueFormatter } from "../../utilities/tableUtility";

export const v2DefaultColDef = {
  ...K.AgGridTable.DefaultColDef,
  valueFormatter: valueFormatter(),
  sortable: true,
};

export const DefaultColumnOptions = {
  Id: {
    headerName: "ID",
    field: "id",
    lockVisible: true,
    sortable: true,
    minWidth: 150,
    maxWidth: 200,
  },
  Actions: {
    headerName: "Actions",
    field: "actions",
    lockVisible: true,
    pinned: "right",
    suppressMovable: true,
    lockPinned: true,
    sortable: false,
  },
};
